
import { Dossier } from "@/models/dossier";
import Vue from "vue";
import AppDossierSearch from "@/components/dossier/DossierSearch.vue";
import AppCompanyCreateCard from "@/components/company/CompanyCreateCard.vue";
import { CompanyDossierService, CompanyService } from "@/services";
import { Company } from "@/models/company";
import { ServerConfig } from "@/config/config";

export default Vue.extend({
	data(){
		return {
			createCompanyOpen: false
		};
	},
	props: {
		targetDossier: {
			type: Object as ()=>Dossier,
		},
		sourceDossier: {
			type: Object as ()=>Dossier,
			required: true
		},
		sourceCompany: {
			type: Object as ()=>Company,
			required: true
		}
	},
	computed: {
		defaultTargetDbId():number | null{
			return ServerConfig.defaultTestingDbId;
		}
	},
	methods: {
		setDossier(event:Dossier){
			this.$emit("dossier", event);
		},
		async onCompanyCreated(companyId:number){
			let company = await CompanyService.getCompany(companyId);
			company.isDemo = this.sourceCompany.isDemo;
			company.employeeAccount = true;
			company.tier = this.sourceCompany.tier;
			await CompanyService.updateCompany(company);

			let missingModules = this.sourceCompany.modules.filter(m=>company.modules.find(m2=>m2.id == m.id) == null);
			let toRemoveModules = company.modules.filter(m=>this.sourceCompany.modules.find(m2=>m2.id == m.id) == null);
			await CompanyService.removeModulesFromCompany(company, toRemoveModules);
			await CompanyService.addModulesToCompany(company, missingModules);

			if (company.dossiers.length == 0) return;
			let dossier = await CompanyDossierService.getDossier(companyId, company.dossiers[0].id);
			dossier.company = company;
			console.log(dossier);
			this.setDossier(dossier);
			this.createCompanyOpen = false;
		}
	},
	components: {
		AppDossierSearch,
		AppCompanyCreateCard
	}
});
